export function About() {
  return (
    <section id="about" className="py-32 px-8" style={{ backgroundColor: '#FAFAF8' }}>
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-5 gap-20 items-start">
          {/* Left Column - Text */}
          <div className="md:col-span-2 space-y-8">
            <p className="text-xs uppercase tracking-[0.2em] font-medium" style={{ color: '#C67B5C' }}>
              OUR STORY
            </p>
            
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight" style={{ fontFamily: 'Playfair Display, serif', lineHeight: '1.15' }}>
              Built on Community Values
            </h2>
            
            <div className="space-y-6 text-gray-700 leading-relaxed" style={{ fontSize: '17px', lineHeight: '1.7' }}>
              <p>
                For over a decade, we've been proud to serve our local community with carefully curated products and personalized service. What started as a small passion project has grown into a beloved neighborhood destination.
              </p>
              <p>
                We believe in supporting local artisans, sustainable practices, and building lasting relationships with our customers. Every item in our shop is selected with care, ensuring quality and value for the people we serve.
              </p>
              <p>
                When you shop with us, you're not just making a purchase—you're supporting a local business that reinvests in the community we all call home.
              </p>
            </div>
          </div>

          {/* Right Column - Images */}
          <div className="md:col-span-3 space-y-6">
            <div className="rounded-3xl overflow-hidden shadow-lg">
              <img 
                src="https://readdy.ai/api/search-image?query=charming%20local%20retail%20shop%20exterior%20storefront%20with%20large%20display%20windows%20welcoming%20entrance%20wooden%20door%20hanging%20sign%20plants%20and%20flowers%20outside%20bright%20daylight%20small%20business%20facade%20neighborhood%20shopping%20street%20warm%20inviting%20atmosphere%20professional%20photography&width=900&height=500&seq=shop-exterior-view&orientation=landscape"
                alt="Shop Exterior"
                className="w-full h-full object-cover"
                style={{ aspectRatio: '16/9' }}
              />
            </div>
            
            <div className="rounded-3xl overflow-hidden shadow-lg">
              <img 
                src="https://readdy.ai/api/search-image?query=friendly%20shop%20owner%20helping%20customer%20inside%20boutique%20retail%20store%20warm%20interaction%20smiling%20faces%20personal%20service%20local%20business%20authentic%20moment%20natural%20lighting%20welcoming%20atmosphere%20community%20connection%20professional%20lifestyle%20photography&width=900&height=500&seq=owner-customer-interaction&orientation=landscape"
                alt="Customer Service"
                className="w-full h-full object-cover"
                style={{ aspectRatio: '16/9' }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}